import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '';
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

const r365Service = {
  getStatus: () =>
    axios.get(`${BASE}/api/r365/status`, auth()).then(r => r.data),

  saveCredentials: (payload) =>
    axios.put(`${BASE}/api/r365/credentials`, payload, auth()).then(r => r.data),

  testConnection: () =>
    axios.post(`${BASE}/api/r365/test-connection`, {}, auth()).then(r => r.data),
};

export default r365Service;
